// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"a28b7d61","795":"a28b7d61"}[chunkId] + ".chunk.css";
};